/**
 * @phxMobileDatePicker
 */
import { EABError } from 'core-js-error';

angular.module('ui-ng-mobile-date-picker', ['ui-ng-delegate']);

require('./components/date_picker_controller');

require('./servants/date_picker_base_servant');
require('./servants/date_picker_default_servant');
require('./servants/date_picker_scheduling_servant');

export * from './date_picker_interface';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-mobile-date-picker/src/main.ts